import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import EmailStep from "./Steps/Email";
import PasswordStep from "./Steps/Password";
import OTPStep from "./Steps/OTP";
import { FormTitle } from "../components/FormComponents";
import { AnchorLogo } from 'seagull/icons';
import { Callout } from 'seagull';
import { routes } from "../../../constants";
import styles from "./LoginScreen.module.scss";
export function getClientViewURL(pathname) {
  return "".concat(pathname, "?view=client");
}
export function LoginScreen() {
  var _location$state;
  const location = useLocation();
  const clientView = location.pathname === routes.redirect || new URLSearchParams(location.search).get('view') === 'client';
  const [currentStep, setCurrentStep] = useState({
    step: 'email'
  });
  const [hasPassword, setHasPassword] = useState(false);
  useEffect(() => {
    document.title = 'Anchor Login';
  }, []);
  function getTitleMP() {
    return /*#__PURE__*/React.createElement(FormTitle, null, clientView ? /*#__PURE__*/React.createElement(AnchorLogo, {
      className: styles.logo
    }) : 'Welcome to Anchor');
  }
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    animatedBackground: !clientView,
    hideBanner: clientView,
    testId: "login-form"
  }, currentStep.step === 'email' && /*#__PURE__*/React.createElement(EmailStep, {
    onSubmit: _ref => {
      let {
        email,
        hasPassword
      } = _ref;
      setCurrentStep({
        step: hasPassword ? 'password' : 'otp',
        email
      });
      setHasPassword(hasPassword);
    },
    titleMP: getTitleMP(),
    subtitleMP: clientView ? /*#__PURE__*/React.createElement(FormTitle, null, "Login to continue") : (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.sessionTimeout ? /*#__PURE__*/React.createElement(Callout, {
      hideIcon: true,
      intent: "error",
      "data-testid": "session-timeout-error"
    }, "You have been automatically signed out due to inactivity.") : null
  }), currentStep.step === 'password' && /*#__PURE__*/React.createElement(PasswordStep, {
    email: currentStep.email,
    onClickRequestOTP: () => {
      setCurrentStep({
        step: 'otp',
        email: currentStep.email
      });
    },
    titleMP: getTitleMP(),
    subtitleMP: clientView ? /*#__PURE__*/React.createElement(FormTitle, null, "Login to continue") : null
  }), currentStep.step === 'otp' && /*#__PURE__*/React.createElement(OTPStep, {
    email: currentStep.email,
    hasPassword: hasPassword
  }));
}